const minRootPx = 50 // 根字号下限，避免太小难看清

/**
 * 按视口选用设计稿宽度，PC / iPad 共用同一套档位（与 UI 稿子：1920 / 1600 / 1366 / 1024 / 820 / 768 / 375）
 * 规则：min 严格降序；第一个满足 width >= min 的条目的 design 为除数。
 * 在「本档 min ≤ 宽度 < 上一档 min」内，用该档 design，在宽度等于该档 min 时根字号约为 100px。
 *
 * 375～767 若仍用 375 作除数，拉宽窗口时根字体会过大（如 767 宽时约 204px），故该区间沿用 768 稿；
 * 小于 375 的极窄屏用 375 稿。若你只做固定 375 宽 H5，可在外层 max-width + 独立 rem 策略。
 */
const PC_DESIGN_TIERS = [
  { min: 1920, design: 1920 },
  { min: 1600, design: 1600 },
  { min: 1366, design: 1366 },
  { min: 1024, design: 1024 },
  { min: 820, design: 820 },
  { min: 768, design: 768 },
  /*{ min: 375, design: 768 },
  { min: 0, design: 375 }*/
]

function getDesignWidth(width) {
  for (let i = 0; i < PC_DESIGN_TIERS.length; i++) {
    const { min, design } = PC_DESIGN_TIERS[i]
    if (width >= min) return design
  }
  return PC_DESIGN_TIERS[PC_DESIGN_TIERS.length - 1].design
}

function setRem() {
  const docEl = document.documentElement
  const width = docEl.clientWidth
  if (!width) return

  const offset = getDesignWidth(width);
  window.offset = offset;

  let rootPx = (width / offset) * 100
  if (rootPx < minRootPx) rootPx = minRootPx

  // 取整减轻模糊
  docEl.style.fontSize = Math.round(rootPx) + 'px'
}

export function initRem() {
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  setRem()
  window.addEventListener(resizeEvt, setRem, false)
  document.addEventListener('DOMContentLoaded', setRem, false)
}